//数据分析
const Analysis = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideDataAnalysis/analysisList.vue')
const Space = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideDataAnalysis/space.vue')
const Equipment = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideDataAnalysis/equipment.vue')
const ChargeUserRank = () => import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideDataAnalysis/chargeUserRank.vue')
const OverTimeOrder=()=>import(/*webpackChunkName:'operation'*/'@/page/operation/roadsideDataAnalysis/overTimeOrder.vue')

const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const roadsideAnalysis={
    path: '/main/dataAnalysis',
    name: '数据分析',
    component: RouteTemp,
    children: [{
        path: '/main/dataAnalysis/pay',
        name: '缴费情况分析',
        component: Analysis,
        meta: {
            requireAuth: true,
        },
    }, {
        path: '/main/dataAnalysis/space',
        name: '泊位使用分析',
        component: Space,
        meta: {
            requireAuth: true,
        },
    }, {
        path: '/main/dataAnalysis/equipment',
        name: '设备状态分析',
        meta: {
            requireAuth: true,
        },
        component: Equipment
    },{
        path: '/main/dataAnalysis/over-time-order',
        name: '未下单数据分析',
        meta: {
            requireAuth: true,
        },
        component: OverTimeOrder
    }, {
        path: '/main/dataAnalysis/chargeUserRank',
        name: '收费排名',
        meta: {
            requireAuth: true,
        },
        component: ChargeUserRank
    }
    ]
}